---
nb:
  event_mapping:
    destroy_warning: Dette vil slette alle tidligere hendelseskartlegginger for denne vindturbinen, er du sikker på at du vil fortsette?
    file_too_large: Filen er for stor
    import: Importer hendelseskartlegging
    invalid_file: Filen kunne ikke leses. Den kan være skadet eller i feil format.
    no_file_selected: Ingen fil valgt
    title: Hendelseskartlegging
    xlsx_file_input: XLSX-fil som skal lastes opp
